module.exports = __webpack_public_path__ + "img/facebook.fa431d0b.svg";